import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SaveFileResultTable from "./SaveFileResultTable"

function SaveFileResultModal(args) {
    console.log("SaveFileResultModal",args)
    const [modal, setModal] = useState(args.toggle);
    const [data, setData] = useState(args.data);

    const toggle = () => setModal(!modal);

    return (
        <div>
            <Modal size="lg" isOpen={modal} toggle={toggle} onClosed={args.onClosed }>
                <ModalHeader toggle={toggle}>Resultados</ModalHeader>
                <ModalBody>
                    <SaveFileResultTable data={data} />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default SaveFileResultModal;